import axios from "axios";
import { encryptData, decryptData } from "../crypto";

// export function getLocalIP(callback) {
//   const pc = new RTCPeerConnection({ iceServers: [] });
//   const ips = new Set();

//   pc.createDataChannel(""); // create a bogus channel
//   pc.onicecandidate = (event) => {
//     if (!event || !event.candidate) {
//       pc.close();
//       return;
//     }
//     const parts = event.candidate.candidate.split(" ");
//     const ip = parts[4];
//     if (!ips.has(ip)) {
//       ips.add(ip);
//       callback(Array(...ips)[2]);
//     }
//   };
//   pc.createOffer()
//     .then((offer) => pc.setLocalDescription(offer))
//     .catch((err) => console.error("Error creating offer:", err));
// }
export async function getLocalIP(callback) {
  try {
    const ips = await getLocalIPAddress();

    // If we only got .local or nothing -> fallback to public IP
    const hasRealLanIP = ips.some(
      (ip) => !ip.endsWith(".local") && !ip.startsWith("0."),
    );

    if (!hasRealLanIP) {
      const publicIP = await getPublicIP();
      callback(publicIP); // return public IP as array
    } else {
      const length = ips.length - 1;
      const ip = ips[length];
      callback(ip);
    }
  } catch (err) {
    console.error("Error fetching LAN IP:", err);
    // fallback anyway
    const publicIP = await getPublicIP();
    callback(publicIP);
  }
}

const getLocalIPAddress = () => {
  return new Promise((resolve, reject) => {
    if (!window.RTCPeerConnection) {
      reject(new Error("WebRTC not supported"));
      return;
    }

    const rtc = new RTCPeerConnection({ iceServers: [] });
    rtc.createDataChannel("dummy");

    const ipAddresses = new Set();

    rtc.onicecandidate = (event) => {
      if (event.candidate) {
        const candidate = event.candidate.candidate;
        const ipMatch = candidate.match(
          /(192\.168\.\d{1,3}\.\d{1,3}|10\.\d{1,3}\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}|[a-z0-9\-]+\.local)/,
        );
        if (ipMatch) ipAddresses.add(ipMatch[0]);
      } else {
        rtc.close();
        resolve([...ipAddresses]); // might be [] or .local
      }
    };

    rtc
      .createOffer()
      .then((offer) => rtc.setLocalDescription(offer))
      .catch((err) => {
        rtc.close();
        reject(err);
      });
  });
};

const getPublicIP = async () => {
  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    return data.ip; // Example: "103.45.21.55"
  } catch (err) {
    console.error("Error fetching public IP:", err);
    return "0.0.0.0";
  }
};

export const loginApi = async ({ username, password, exam_pin, ip }) => {
  const branch_id = sessionStorage.getItem("selectedBranch");
  const center_id = sessionStorage.getItem("selectedCenter");
  const clientLogo = sessionStorage.getItem("client_logo");

  const userAuth = {
    username,
    password,
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/auth/signin`,
      {
        user: {
          username,
          password,
          exam_pin,
          // branch_id,
          // center_id,
          ip,
        },
      },
    );

    if (response.data.success === true) {
      localStorage.clear();
      sessionStorage.clear();
      sessionStorage.setItem("selectedBranch", branch_id);
      sessionStorage.setItem("selectedCenter", center_id);
      sessionStorage.setItem("userAuth", JSON.stringify(userAuth));
      sessionStorage.setItem("client_logo", clientLogo);

      const examTemplate = encryptData(
        response.data.user.exam_details.exam_template,
      );
      const examToken = encryptData(response.data.token);
      const username = encryptData(response.data.user.full_name);
      const examId = response.data.user.exam_details.id;
      const examInstructions = encryptData(
        (response.data.user.exam_details.genral_instruction_en
          ? "<h3>Exam Instructions</h3>" +
          response.data.user.exam_details.genral_instruction_en
          : "") + response.data.user.exam_details.exam_instruction_en,
      );

      if (response.data.user.exam_details.exam_template === "ipmat") {
        const genralInstructionEn = encryptData(
          response.data.user.exam_details.genral_instruction_en
            ? "<h3>Instructions</h3>" +
            response.data.user.exam_details.genral_instruction_en
            : "",
        );
        const examInstructionEn = encryptData(
          response.data.user.exam_details.exam_instruction_en,
        );

        const genralInstructionHi = encryptData(
          response.data.user.exam_details.genral_instruction_hi
            ? "<h3>निर्देश</h3>" +
            response.data.user.exam_details.genral_instruction_hi
            : "",
        );
        const examInstructionHi = encryptData(
          response.data.user.exam_details.exam_instruction_hi,
        );

        sessionStorage.setItem("genralInstructionEn", genralInstructionEn);
        sessionStorage.setItem("examInstructionEn", examInstructionEn);
        sessionStorage.setItem("genralInstructionHi", genralInstructionHi);
        sessionStorage.setItem("examInstructionHi", examInstructionHi);
      }
      const userId = response.data.user.id;
      const email = encryptData(response.data.user.email);
      const instructionsHindi = encryptData(
        (response.data.user.exam_details.genral_instruction_hi
          ? "<h5>निर्देश</h5>" +
          response.data.user.exam_details.genral_instruction_hi
          : "") + response.data.user.exam_details.exam_instruction_hi,
      );
      const exam_name = encryptData(response.data.user.exam_details.exam_name);
      const subject_selection =
        response.data.user.exam_details.subject_selection;
      const direction = response.data.user.exam_details.direction;

      const exam_type = response.data.user.exam_details.exam_type;
      const enable_submit = response.data.user.exam_details.enable_submit;
      const examInstantResult =
        response.data.user.exam_details.exam_instant_result;
      const starTime = response.data.user.exam_details.start_time.split(":");
      const starTimeParts = String(response.data.user.exam_details.start_time).split(":");
      const cleanHours = starTimeParts[0].padStart(2, '0');
      const cleanMinutes = starTimeParts[1].padStart(2, '0');
      const cleanSeconds = starTimeParts[2].split("+")[0].split("-")[0].padStart(2, '0');
      const rawStartDate = String(response.data.user.exam_details.start_date).trim();
      const startDateTimeStr = `${rawStartDate}T${cleanHours}:${cleanMinutes}:${cleanSeconds}`;

      sessionStorage.setItem("examInstantResult", examInstantResult);

      sessionStorage.setItem("candidateLoggedinToInstructionsPage", true);

      sessionStorage.setItem("exam_name", exam_name);
      sessionStorage.setItem("subject_selection", subject_selection);
      sessionStorage.setItem("direction", direction);
      sessionStorage.setItem("exam_type", exam_type);
      sessionStorage.setItem("enable_submit", enable_submit);
      sessionStorage.setItem("exam_template", examTemplate);
      sessionStorage.setItem("startDateTime", startDateTimeStr);

      sessionStorage.setItem("examId", examId);
      sessionStorage.setItem("examToken", examToken);
      sessionStorage.setItem("email", email);
      sessionStorage.setItem("userName", username);
      sessionStorage.setItem("examInstructions", examInstructions);
      sessionStorage.setItem("instructionsHindi", instructionsHindi);
      sessionStorage.setItem("userId", userId);
      const demoExamId = response.data?.user?.exam_details?.demo_exam_id || response.data?.demo_exam_id || response.data?.user?.demo_exam_id;
      if (demoExamId) {
        sessionStorage.setItem("demoExamId", demoExamId);
      }
      // sessionStorage.setItem("center_feedback", "yes");
      const centerFeedback = response.data?.user?.exam_details?.center_feedback

      if (centerFeedback) {
        sessionStorage.setItem("center_feedback", centerFeedback);
      }

      const keyboardEnable =
        response.data?.user?.exam_details?.keyboard_enable ??
        response.data?.user?.keyboard_enable ??
        response.data?.keyboard_enable;

      if (keyboardEnable !== undefined && keyboardEnable !== null) {
        sessionStorage.setItem("keyboard_enable", keyboardEnable);
      }

      // // login time
      // sessionStorage.setItem("loginTime", new Date().getTime());

      return { success: true, examId, userId };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};
export const loginByClintApi = async ({ exam_id, user_id }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/auth/client/student/signin`,
      {
        user: {
          exam_id,
          user_id,
        },
      },
    );

    if (response.data.success === true) {
      localStorage.clear();
      sessionStorage.clear();

      const examTemplate = encryptData(
        response.data.user.exam_details.exam_template,
      );
      const examToken = encryptData(response.data.token);
      const username = encryptData(response.data.user.full_name);
      const examId = response.data.user.exam_details.id;

      const examInstructions = encryptData(
        (response.data.user.exam_details.genral_instruction_en
          ? "<h3>Exam Instructions</h3>" +
          response.data.user.exam_details.genral_instruction_en
          : "") + response.data.user.exam_details.exam_instruction_en,
      );

      if (response.data.user.exam_details.exam_template === "ipmat") {
        const genralInstructionEn = encryptData(
          response.data.user.exam_details.genral_instruction_en
            ? "<h3>Instructions</h3>" +
            response.data.user.exam_details.genral_instruction_en
            : "",
        );
        const examInstructionEn = encryptData(
          response.data.user.exam_details.exam_instruction_en,
        );

        const genralInstructionHi = encryptData(
          response.data.user.exam_details.genral_instruction_hi
            ? "<h3>निर्देश</h3>" +
            response.data.user.exam_details.genral_instruction_hi
            : "",
        );
        const examInstructionHi = encryptData(
          response.data.user.exam_details.exam_instruction_hi,
        );

        sessionStorage.setItem("genralInstructionEn", genralInstructionEn);
        sessionStorage.setItem("examInstructionEn", examInstructionEn);
        sessionStorage.setItem("genralInstructionHi", genralInstructionHi);
        sessionStorage.setItem("examInstructionHi", examInstructionHi);
      }
      const userId = response.data.user.id;
      const email = encryptData(response.data.user.email);
      const instructionsHindi = encryptData(
        (response.data.user.exam_details.genral_instruction_hi
          ? "<h5>निर्देश</h5>" +
          response.data.user.exam_details.genral_instruction_hi
          : "") + response.data.user.exam_details.exam_instruction_hi,
      );
      const exam_name = encryptData(response.data.user.exam_details.exam_name);
      const subject_selection =
        response.data.user.exam_details.subject_selection;
      const direction = response.data.user.exam_details.direction;
      const exam_type = response.data.user.exam_details.exam_type;
      const enable_submit = response.data.user.exam_details.enable_submit;
      const clientLogo = response.data.user.client_logo;

      const examInstantResult =
        response.data.user.exam_details.exam_instant_result;
      const starTime = response.data.user.exam_details.start_time.split(":");
      const startDateTime = new Date(
        response.data.user.exam_details.start_date,
      );
      startDateTime.setHours(starTime[0]);
      startDateTime.setMinutes(starTime[1]);
      startDateTime.setSeconds(starTime[2].split("+")[0]);

      sessionStorage.setItem("examInstantResult", examInstantResult);

      sessionStorage.setItem("candidateLoggedinToInstructionsPage", true);

      sessionStorage.setItem("exam_name", exam_name);
      sessionStorage.setItem("subject_selection", subject_selection);
      sessionStorage.setItem("direction", direction);
      sessionStorage.setItem("exam_type", exam_type);
      sessionStorage.setItem("enable_submit", enable_submit);
      sessionStorage.setItem("exam_template", examTemplate);
      sessionStorage.setItem("startDateTime", startDateTime);
      sessionStorage.setItem("client_logo", clientLogo);

      sessionStorage.setItem("examId", examId);
      sessionStorage.setItem("examToken", examToken);
      sessionStorage.setItem("email", email);
      sessionStorage.setItem("userName", username);
      sessionStorage.setItem("examInstructions", examInstructions);
      sessionStorage.setItem("instructionsHindi", instructionsHindi);
      sessionStorage.setItem("userId", userId);

      const demoExamId = response.data?.user?.exam_details?.demo_exam_id || response.data?.demo_exam_id || response.data?.user?.demo_exam_id;
      if (demoExamId) {
        sessionStorage.setItem("demoExamId", demoExamId);
      }

      const centerFeedback = response.data?.user?.exam_details?.center_feedback;

      if (centerFeedback) {
        sessionStorage.setItem("center_feedback", centerFeedback);
      }

      const keyboardEnable =
        response.data?.user?.exam_details?.keyboard_enable ??
        response.data?.user?.keyboard_enable ??
        response.data?.keyboard_enable;

      if (keyboardEnable !== undefined && keyboardEnable !== null) {
        sessionStorage.setItem("keyboard_enable", keyboardEnable);
      }

      // // login time
      // sessionStorage.setItem("loginTime", new Date().getTime());

      return { success: true, examId, userId };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const loginApiWithoutPassword = async ({ username, password }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/auth/student/signin`,
      {
        user: {
          username,
          password,
        },
      },
    );
    if (response.data.success === true) {
      // localStorage.clear();
      // sessionStorage.clear();

      const examToken = encryptData(response.data.token);
      const username = encryptData(response.data.user.full_name);
      const userId = response.data.user.id;
      const email = encryptData(response.data.user.email);
      const clientLogo = response.data.user.client_logo;

      sessionStorage.setItem("candidateLoggedinToDashboard", true);
      sessionStorage.setItem(
        "jeeDetails",
        response.data.registration_learner_data || "no",
      );
      sessionStorage.setItem("userId", userId);
      sessionStorage.setItem("examToken", examToken);
      sessionStorage.setItem("email", email);
      sessionStorage.setItem("userName", username);
      sessionStorage.setItem("client_logo", clientLogo);

      return {
        success: true,
        userId,
        learner: {
          ...response.data.user,
          learner_information: response.data.user.learner_info,
        },
      };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const fetchProfileApi = async () => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/profile`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    return response.data.learner;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const fetchExamLanguages = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/language/by_exam/${examId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    return response.data.language;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

//exam question api
export const fetchQuestionsData = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/questions/${examId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );
    if (response.data.success) {
      // sessionStorage.setItem("client_logo", response.data.clientlogo);
      let count = 0;
      response.data.exam.subjects.map((s) => {
        count += s.subject_question_count;
      });
      sessionStorage.setItem("total", count);
      return response.data.exam;
    }
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};
export const fetchQuestionsDataWithSection = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/questions/section/${examId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );
    sessionStorage.setItem("subject_wise", response.data.exam.subject_wise);
    sessionStorage.setItem(
      "subjectduration",
      JSON.stringify(response.data.exam.subjectduration),
    );
    sessionStorage.setItem("calculator_enable", response.data.exam.calculator_enable);

    let counter = 0;
    response.data.exam.subjects.map((subject) => {
      subject.sections.map((section) => {
        counter += section.question_count;
      });
    });
    sessionStorage.setItem("total", counter);

    return response.data.exam;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

// Current Time api
export const fetchCurrentTimeApi = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/auth/currenttime`,
    );
    return response;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const examStartApi = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/live/${examId}`,
      {}, // This is where you'd put a request body, if needed. Use an empty object if there's no body.
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

//checking for question attempsts api
export const fetchAttemptQuestionsData = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  const url =
    sessionStorage.getItem("subject_wise") !== "yes"
      ? "v1/parikshado/student/exam/attempted/questions"
      : "v1/parikshado/student/exam/attempted/questions/subject";

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/${url}/${examId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );
    if (response.data?.submitted_subjects) {
      const submittedSubjects =
        response.data?.submitted_subjects.map(
          (subject) => subject.subject_id,
        ) || [];
      sessionStorage.setItem(
        "submitted_subjects",
        JSON.stringify(submittedSubjects),
      );
    }

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const saveOptions = async ({
  exam_id,
  subject_id,
  question_id,
  option_id,
  attempt_status,
  remaining_time,
  time_taken,
  section_id,
  current_question,
  next_question,
  match_matrix,
  clear,
  text,
  currentQuestion,
}) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  if (currentQuestion) {
    sessionStorage.setItem("lastAttempted", currentQuestion);
  }
  sessionStorage.setItem("lastExamApiActivityAt", String(Date.now()));
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/attempt`,
      {
        clear: clear || "",
        attempt: {
          exam_id,
          subject_id,
          question_id,
          option_id,
          attempt_status,
          remaining_time,
          time_taken,
          match_matrix,
          section_id,
          current_question:
            current_question !== next_question ? current_question || "" : "",
          next_question:
            current_question !== next_question ? next_question || "" : "",
          text,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    if (response.data.success === true) {
      return { success: true };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const isExamSubmittedByHead = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/auth/submitcheck/${examId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    if (response.data.success === true) {
      if (response.data.status === true) {
        localStorage.clear();

        // sessionStorage.setItem("examResult", examResult);

        sessionStorage.setItem("examSubmitted", true);
        sessionStorage.removeItem("examStarted");
        sessionStorage.removeItem("instructionsHindi");
        sessionStorage.removeItem("examInstructions");
      }

      const examResult = JSON.stringify(response.data);
      return {
        success: true,
        examResult: examResult,
        status: response.data.status,
      };
    }
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const saveRemainingTimeApi = async ({
  exam_id,
  learner_Id,
  remaining_time,
}) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/remaining_time`,
      {
        exam_id,
        learner_Id,
        remaining_time,
      },
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("saveRemainingTimeApi error:", error);
    return { success: false };
  }
};

export const submitApi = async ({ examId, type }) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  if (type === "time") {
    const userId = sessionStorage.getItem("userId");
    await saveRemainingTimeApi({
      exam_id: examId,
      learner_Id: userId,
      remaining_time: sessionStorage.getItem("remainingTime"),
    });
  }
  const body = {
    exam_submit: {
      exam_id: examId,
      type,
    },
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/submit`,
      body,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    if (response.data.success === true) {
      const examResult = JSON.stringify(response.data);
      // sessionStorage.setItem("examResult", examResult);

      // localStorage.clear();
      // sessionStorage.clear();

      sessionStorage.setItem("examSubmitted", true);
      sessionStorage.removeItem("examStarted");
      sessionStorage.removeItem("instructionsHindi");
      sessionStorage.removeItem("examInstructions");

      return { success: true, examResult: examResult };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const submitWarning = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/check_before_submit/${examId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    return response.data.submitWarning;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};
export const fetchSummaryApi = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/check_before_submit/summary/${examId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const checkBeforeSubmitSummary = fetchSummaryApi;

export const getBranch = async () => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/auth/branch`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const getCenter = async (id) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/auth/center/${id}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const submitStatus = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/status/live/${examId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const fetchTodayExam = async () => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/today/all/exam`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );
    return response.data.exams;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};
export const fetchQuestionPaperApi = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/by_exam/${examId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};
export const fetchQuestionPaperBySubjectApi = async (examId, subjectId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/exam/question/subject_id`,
      {
        data: {
          exam_id: examId,
          subject_id: subjectId,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const instructionLogsApi = async (data) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/logs/instruction/page`,
      data,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const addSummaryPageLogApi = async (payload) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const userId = sessionStorage.getItem("userId");

  const finalPayload = {
    user_id: Number(userId) || userId,
    student_id: Number(userId) || userId,
    ...payload,
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/logs/add`,
      finalPayload,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Summary page log API error:", error);

    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    }

    return {
      success: false,
      message: "An error occurred during the API request.",
    };
  }
};

export const uploadExamSummaryScreenshotApi = async (examId, screenshotBase64) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const userId = sessionStorage.getItem("userId");

  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/summary-screenshot`,
      {
        exam_id: Number(examId) || examId,
        user_id: Number(userId) || userId,
        file: screenshotBase64,
      },
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Upload summary screenshot API error:", error);
    return { success: false, message: error.message };
  }
};

export const examStartApiSubject = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/live/subject/${examId}`,
      {}, // This is where you'd put a request body, if needed. Use an empty object if there's no body.
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const submitWarningSubWise = async (examId, subjectId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  // const subjectId = sessionStorage.getItem("subjectId");

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/check_before_submit/subject/${examId}?subjectId=${subjectId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const subjectSubmitApi = async (examId, activeSubjectId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const body = {
    exam_submit: {
      exam_id: examId,
      subject_id: activeSubjectId,
    },
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/subject/submit`,
      body,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    if (response.data.success === true) {
      const examResult = JSON.stringify(response.data);
      // sessionStorage.setItem("examResult", examResult);

      // localStorage.clear();
      // sessionStorage.clear();

      // sessionStorage.setItem("examSubmitted", true);
      // sessionStorage.removeItem("examStarted");
      // sessionStorage.removeItem("instructionsHindi");
      // sessionStorage.removeItem("examInstructions");

      return { success: true, examResult: examResult };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const addJeeDetails = async (data) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/auth/registration_learner_data`,
      data,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    if (response.data.success === true) {
      return { success: true };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const getSelectedSubjects = async () => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const examId = sessionStorage.getItem("examId");

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/subject_wise/submit/${examId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const setSelectedSubjects = async (examId, activeSubjectId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const body = {
    subject: {
      exam_id: examId,
      subject_id: activeSubjectId,
      status: "selected",
    },
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/subject_wise/submit`,
      body,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    if (response.data.success === true) {
      const examResult = JSON.stringify(response.data);
      return { success: true, examResult: examResult };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};
export const runCode = async (data) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const body = {
    ...data
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/run/coding`,
      body,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      },
    );

    if (response.data.success === true) {
      return response.data;
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};
export const timeTakenApi = async (data) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/time_taken`,
      data,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );

    if (response.data.success === true) {
      return { success: true };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    // Fails silently, returning success: false so it doesn't impact exam
    return { success: false, message: "An error occurred during the API request." };
  }
};
export const checkLoginStatus = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/auth/login_check`,
      { exam_id: examId },
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const fetchCenterFeedbackQuestions = async (examId) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/questions_center_feedback/${examId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("fetchCenterFeedbackQuestions API error:", error);
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const submitCenterFeedback = async (payload) => {
  const decryptedToken = decryptData(sessionStorage.getItem("examToken"));

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/center_feedback_attempt/question`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("submitCenterFeedback API error:", error);
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const verifyPreviewTokenApi = async ({ preview_token, exam_id }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/preview/verify`,
      {
        preview_token,
        exam_id: Number(exam_id) || exam_id,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (
      response.data &&
      (response.data.success === true || response.data.verified === true)
    ) {
      return {
        success: true,
        verified: true,
        data: response.data,
      };
    } else {
      return {
        success: false,
        message:
          response.data?.message ||
          "Preview link is invalid, expired, or already used",
      };
    }
  } catch (error) {
    console.error("Preview verification error:", error);

    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      return {
        success: false,
        message: "Preview link is invalid, expired, or already used",
      };
    }
  }
};
